import type { AdPartnerState } from '../../../main/types/adPartnerTypes';

export const INIT_STATE: AdPartnerState = {
  ad_ontology: undefined,
  partners: [],
  orgPartners: {},
  selectedPartner: null,
  unsavedChanges: false,
  error: null,
  loading: false,
  accessToken: null,
  hasPartnersLoaded: false,
  mfReadyForSave: false,
  partnersBackup: [],
  customPartnerLimits: null,
  customPartnerLimitsLoading: false,
  customPartnerLimitsError: null,
  connections: null,
  connectionsLoading: false,
  connectionsError: null,
};
